import { Alert, Col, Row } from 'antd';
import { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from 'common/components';

interface Props {
  disableContinue?: boolean;
  onBack?: () => void;
  onContinue?: () => void;
  onSkip?: () => void;
  softContinueHint?: boolean;
}

export default function PageControls({ disableContinue, onBack, onContinue, onSkip, softContinueHint }: Props) {
  const { t } = useTranslation();
  const footerRef = useRef<HTMLDivElement>(null);
  const continueLabel = softContinueHint
    ? t('informationsFeature.softContinueProceed')
    : t('informationsFeature.continue');

  useEffect(() => {
    if (!softContinueHint) {
      return;
    }
    const footer = footerRef.current;
    if (!footer) {
      return;
    }

    const scrollFooterIntoView = () => {
      footer.scrollIntoView({ block: 'end', behavior: 'smooth' });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(scrollFooterIntoView);
    });
  }, [softContinueHint]);

  return (
    <div ref={footerRef} style={{ scrollMarginBottom: 24 }}>
      {softContinueHint ? (
        <Alert
          type="warning"
          showIcon
          title={<Trans i18nKey="informationsFeature.softContinueHint" components={{ strong: <strong /> }} />}
          style={{ marginTop: 40, marginBottom: 16 }}
        />
      ) : null}
      <Row justify="end" gutter={10} style={{ margin: softContinueHint ? '0 0 40px' : '40px 0' }}>
        {onSkip ? (
          <Col>
            <Button onClick={onSkip} size="large">
              {t('informationsFeature.skip')}
            </Button>
          </Col>
        ) : null}
        <Col>
          <Button onClick={onBack} size="large">
            {t('informationsFeature.back')}
          </Button>
        </Col>
        <Col>
          <Button type="primary" onClick={onContinue} size="large" disabled={disableContinue}>
            {continueLabel}
          </Button>
        </Col>
      </Row>
    </div>
  );
}
